import type { FC, InputHTMLAttributes } from "react";

export type ToggleSize = "toggle-xs" | "toggle-sm" | "toggle-md" | "toggle-lg";

export type ToggleUIProps = {
  label?: string;
  toggleSize?: ToggleSize;
  className?: string;
} & InputHTMLAttributes<HTMLInputElement>;

export const ToggleUI: FC<ToggleUIProps> = ({
  label = null,
  toggleSize = "toggle-md",
  className = "",
  ...rest
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <label className="flex items-center text-xs cursor-pointer">
        {label && <span className="label-text mr-2">{label}</span>}
        <input
          type="checkbox"
          className={`toggle toggle-primary${
            toggleSize ? ` ${toggleSize}` : ""
          }`}
          {...rest}
        />
      </label>
    </div>
  );
};
